import {Column} from 'react-table'
import {PageActionsCell} from './PageActionsCell'
import {PageCustomHeader} from './PageCustomHeader'
import {PageModel} from "../../core/_model";
import {PageSelectionHeader} from "./PageSelectionHeader";
import {PageSelectionCell} from "./PageSelectionCell";
import PagePublishStatus from "./PagePublishStatus";
import PageTitleRow from "./PageTitleRow";


const usersColumns: ReadonlyArray<Column<PageModel>> = [
  {
    Header: (props) => <PageSelectionHeader tableProps={props} />,
    id: 'selection',
    Cell: ({...props}) => <PageSelectionCell id={props.data[props.row.index].id} />,
  },
  {
    Header: (props) => <PageCustomHeader tableProps={props} title='عنوان پست' className='min-w-125px' />,
    id: 'title',
    Cell: ({...props}) => <PageTitleRow Post={props.data[props.row.index]} />
  },
  {
    Header: (props) => (
        <PageCustomHeader tableProps={props} title='تاریخ' className='min-w-125px' />
    ),
    accessor: 'dateString',
    // Cell: ({...props}) => <UserLastLoginCell last_login={props.data[props.row.index].last_login} />,
  },
  {
    Header: (props) => <PageCustomHeader tableProps={props} title='توضیحات' className='min-w-125px' />,
    accessor: 'description',
  },

  {
    Header: (props) => (
      <PageCustomHeader tableProps={props} title='وضعیت' className='min-w-125px' />
    ),
    id: 'postType',
    Cell: ({...props}) => <PagePublishStatus ispayment={props.data[props.row.index].postType} />,
  },
  {
    Header: (props) => (
      <PageCustomHeader tableProps={props} title='*' className='text-end min-w-100px' />
    ),
    id: 'actions',
    Cell: ({...props}) => <PageActionsCell id={props.data[props.row.index].id} />,
  },
]

export {usersColumns}
